(function () {
  var NEAREST_COUNT = 3; // cuántas tiendas cercanas mostrar como máximo

  var input = document.getElementById("search-store");
  var searchButton = document.getElementById("search-store-button");
  var resetButton = document.getElementById("search-store-reset");
  var message = document.getElementById("search-store-message");
  var stores = document.querySelectorAll("#our-stores .store-container");

  // El buscador necesita que Google Maps haya terminado de cargar
  // (tarda un instante). Mientras tanto, desactivamos el botón.
  if (searchButton) {
    if (!(window.google && window.google.maps && window.google.maps.Geocoder)) {
      searchButton.disabled = true;
      searchButton.textContent = "Cargando...";
      document.addEventListener("storesMapReady", function () {
        searchButton.disabled = false;
        searchButton.textContent = "Buscar";
      });
    }
  }

  function showMessage(text) {
    message.textContent = text;
    message.style.display = text ? "block" : "none";
  }

  function resetStores() {
    stores.forEach(function (store) {
      store.classList.remove("hidden");
      var distanceItem = store.querySelector(".info-item.distance");
      if (distanceItem) distanceItem.style.display = "none";
    });
    resetButton.style.display = "none";
    showMessage("");
  }

  // Distancia entre dos puntos (lat/lng) en kilómetros — fórmula de Haversine
  function distanceKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLng = ((lng2 - lng1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // Convierte el código postal en coordenadas usando el Geocoder de la
  // librería de Google Maps ya cargada en el navegador (respeta la
  // restricción de dominio de la clave, a diferencia de la API REST).
  function geocodePostcode(postcode) {
    return new Promise(function (resolve, reject) {
      if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
        reject(new Error("El mapa todavía no ha terminado de cargar"));
        return;
      }

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: postcode + ", España" },
        function (results, status) {
          if (status === "OK" && results && results[0]) {
            var loc = results[0].geometry.location;
            resolve({ lat: loc.lat(), lng: loc.lng() });
          } else {
            reject(new Error("No se ha podido encontrar ese código postal"));
          }
        }
      );
    });
  }

  function runSearch() {
    var postcode = input.value.trim();

    if (!postcode) {
      resetStores();
      return;
    }

    showMessage("Buscando...");

    geocodePostcode(postcode)
      .then(function (userCoords) {
        var results = [];

        stores.forEach(function (store) {
          var lat = parseFloat(store.getAttribute("data-lat"));
          var lng = parseFloat(store.getAttribute("data-lng"));
          if (isNaN(lat) || isNaN(lng)) return;

          var dist = distanceKm(userCoords.lat, userCoords.lng, lat, lng);
          results.push({ store: store, distance: dist });
        });

        if (!results.length) {
          showMessage("No hay tiendas con coordenadas cargadas todavía.");
          return;
        }

        results.sort(function (a, b) {
          return a.distance - b.distance;
        });

        var nearestSet = results.slice(0, NEAREST_COUNT);
        var nearestStores = nearestSet.map(function (r) {
          return r.store;
        });

        stores.forEach(function (store) {
          var distanceItem = store.querySelector(".info-item.distance");
          if (nearestStores.indexOf(store) === -1) {
            store.classList.add("hidden");
            if (distanceItem) distanceItem.style.display = "none";
          } else {
            store.classList.remove("hidden");
            var match = nearestSet.filter(function (r) {
              return r.store === store;
            })[0];
            if (distanceItem && match) {
              var distanceText = distanceItem.querySelector(".distance-text");
              if (distanceText) {
                distanceText.textContent = match.distance.toFixed(1) + " km";
              }
              distanceItem.style.display = "flex";
            }
          }
        });

        resetButton.style.display = "inline-block";
        showMessage("");

        // Movemos el mapa para centrarlo en las tiendas encontradas
        if (window.focusStoresOnMap) {
          var nearestIds = nearestSet
            .map(function (r) {
              return r.store.getAttribute("data-location-id");
            })
            .filter(Boolean);
          window.focusStoresOnMap(nearestIds);
        }
      })
      .catch(function () {
        showMessage(
          "No se ha podido encontrar ese código postal. Revisa que esté bien escrito."
        );
      });
  }

  if (searchButton) {
    searchButton.addEventListener("click", runSearch);
  }

  if (input) {
    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        runSearch();
      }
    });
  }

  if (resetButton) {
    resetButton.addEventListener("click", function () {
      input.value = "";
      resetStores();
    });
  }
})();